import React from "react";
import FeatherIcon from "feather-icons-react";

const FilePreviewList = ({ files = [], setSelectedFile,isLoading }:any) => {
  if (files?.length === 0) return null;
  const onRemove=(index:any)=>{
    setSelectedFile((prev:any) => prev?.filter((_:any, i:any) => i !== index))
  }
  return (
    <div className="mt-2">
      {/* <strong>Selected Files:</strong> */}
      <div className="file-list">
        {files?.map((file:any, index:any) => (
          <div
            key={index}
            className="preview-file"
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FeatherIcon icon="file" size={15} />
              <span style={{ fontSize: "14px" }}>{file.name}</span>
              <span style={{ fontSize: "12px", color: "#777" }}>
                ({(file.size / 1024).toFixed(1)} KB)
              </span>
            </div>
            <button
              type="button"
              onClick={() => onRemove(index)}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                color: "#dc3545",
              }}
              title="Remove file"
              disabled={isLoading}
            >
              <FeatherIcon icon="x" size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilePreviewList;
